import { useRouter } from 'next/router';
import { useNavInfoContext } from 'providers/NavInfoProvider';
import { useViewContext } from 'providers/ViewContextProvider';
import { useEffect, useMemo } from 'react';

export const desktopBlueNavbarThreshold = 300;
export const mobileBlueNavbarThreshold = 125;

const useWhiteHeader = () => {
  const { isMobileMenuOpen, scrollDownRange } = useNavInfoContext();
  const { isMobileView } = useViewContext();
  const { pathname } = useRouter();
  const isOnTop = scrollDownRange < 100;
  const isWhiteHeader = useMemo(() => {
    if (isMobileView && isMobileMenuOpen) {
      return true;
    }

    if (
      [
        '/',
        '/search',
        '/categories/[categoryId]',
        '/categories/[categoryId]/article/[articleId]',
        '/contact',
      ].includes(pathname)
    ) {
      return isMobileView
        ? scrollDownRange >= mobileBlueNavbarThreshold
        : scrollDownRange >= desktopBlueNavbarThreshold;
    }

    return true;
  }, [isMobileMenuOpen, isMobileView, pathname, scrollDownRange]);

  useEffect(() => {
    if (isMobileView) {
      if (isOnTop) {
        // header color
        if (isWhiteHeader) {
          document.documentElement.style.backgroundColor = 'unset';
        } else {
          document.documentElement.style.backgroundColor = '#2091F1';
        }
      } else {
        // footer color
        document.documentElement.style.backgroundColor = '#001536';
      }
    }
  }, [isWhiteHeader, isOnTop]);

  return isWhiteHeader;
};

export default useWhiteHeader;
